export default __webpack_public_path__ + "static/media/icon_bar_chart.6792b2a7.svg";